import KFocused from '../../core/mixins/focused/KFocused'
import _ from 'lodash'

export default {
  name: 'KForm',
  componentName: 'KForm',
  provide() {
    return {
      kForm: this,
    }
  },
  mixins: [KFocused],
  props: {
    model: Object, // 对应的form数据对象
    rules: Object,
    inline: {
      type: Boolean,
      default: false,
    },
    stack: {
      type: Boolean,
      default: false,
    },
    labelWidth: {
      type: String,
      default: '',
    },
    labelJustify: {
      type: String,
      default: '', // flex justify-content
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: [],
      pristine: true,
      dirty: false,
      touched: false,
      untouched: true,
      changed: false,
    }
  },
  computed: {},
  watch: {
    touched(val) {
      this.untouched = !val
    },
  },
  created() {
    this.$on('k.form.addField', field => {
      field && this.fields.push(field)
    }).$on('k.form.removeField', field => {
      field.prop && _.remove(this.fields, f => f === field)
    })
  },
  mounted() {
  },
  render() {
    const formClass = {
      'km-form': true,
      'km-form--inline': this.inline,
      'km-form--stack': this.stack,
      'km-form--loading': this.loading,
    }

    const data = {
      class: formClass,
    }

    return <form {...data}>{this.$slots.default}</form>
  },
  methods: {
    validate(props) {
      return new Promise((resolve, reject) => {
        if (!this.model) {
          return reject('form validate:未设置验证数据模型model')
        }
        let valid = true
        let fields = this.fields
        if (props) {
          !_.isArray(props) && (props = [props])
          props.length && (fields = _.filter(fields, f => _.includes(props, f.prop)))
        }
        if (!fields.length) {
          return resolve()
        }
        let invalidFields = {}
        _.forEach(fields, (field, index) => {
          field.validate('', (message, field) => {
            message && (valid = false)
            _.assign(invalidFields, field)
            if (index === fields.length - 1) {
              valid ? resolve() : reject(invalidFields)
            }
          })
        })
      })
    },
    reset() {
      if (!this.model) {
        // return console.warn('form reset:未设置重置数据模型model')
      }
      this.fields.forEach(field => {
        field.reset()
      })
    },
    setCurrentAsDefault(clearError = true) {
      if (!this.model) {
        // return console.warn('form reset:未设置重置数据模型model')
      }
      this.fields.forEach(field => {
        field.setCurrentAsDefault(clearError)
      })
    },
    checkChange(change) {
      if (!this.model) {
        // return console.warn('form reset:未设置重置数据模型model')
      }
      if (change) {
        this.changed = true
      } else {
        let changed = false
        _.forEach(this.fields, f => {
          if (f.changed) {
            changed = true
            return false
          }
        })
        this.changed = changed
      }
    },
    clearValidate(props = []) {
      const fields = props.length
        ? (typeof props === 'string'
          ? this.fields.filter(field => props === field.prop)
          : this.fields.filter(field => props.indexOf(field.prop) > -1)
        ) : this.fields
      fields.forEach(field => {
        field.clearValidate()
      })
    },
    isChanged() {
      return this.changed
    },
  },
}
